export default __webpack_public_path__ + "static/media/category_sprite.eaeb0403.svg";